import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';
import cartApi from '@elab/core/store/cart/api';

const getBaseUri = () => `${apiUtils.getBaseUri()}`;

const getCartTransactionApi = (cartId, userId, cardNumber = '', type = 'giftcards') => {
    cardNumber = encodeURIComponent(cardNumber);
    return `${cartApi.getCurrentCartApiService(userId, cartId)}/${type}/${cardNumber}`;
};

const checkCardBalance = async cardNumber => {
    const uri = `${getBaseUri()}/giftcards?fields=DEFAULT`;
    const giftCard = {
        cardNumber,
    };
    const response = await HTTPClient().postJson(uri, giftCard);

    if (!response.ok) {
        const { errors } = await response.json();
        throw errors[0];
    }

    return response.json();
};

const removeGiftCardTransaction = async (cartId, userId, cardNumber) => {
    const uri = `${getCartTransactionApi(cartId, userId)}`;
    const response = await HTTPClient().deleteJson(uri, cardNumber, {
        'Content-Type': 'application/json;charset=UTF-8',
    });

    if (!response.ok) {
        throw new Error(`Unable to remove gift card (${response.status})`);
    }
};

const removeGiftCardTransactions = async (cartId, userId) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/giftcards`;
    const response = await HTTPClient().delete(uri);

    if (!response.ok) {
        throw new Error(`Unable to remove gift cards (${response.status})`);
    }
};

const updateGiftCardAmount = async (userId, cartId, cardNumber, amountToUse) => {
    const uri = getCartTransactionApi(cartId, userId, cardNumber);

    const response = await HTTPClient().patchJson(uri, {
        appliedAmount: {
            formattedValue: amountToUse,
        },
    });

    if (!response.ok) {
        throw new Error(`Unable to update gift card amount (${response.status})`);
    }
};

export default {
    checkCardBalance,
    removeGiftCardTransaction,
    removeGiftCardTransactions,
    updateGiftCardAmount,
};
